import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
export const minValidator = (min: number, message: string) => {
	return (AC: AbstractControl): ValidationErrors | null => {
		const isError = Validators.min(min)(AC);
		if (isError)
			return {
				min: min,
				actual: AC.value,
				message: message || `Min Value equals to ${min}`,
			};
		return null;
	};
};
